/**
 * Trigger + flag persistence utilities ported from `ometrics-ai` (v1).
 * v2 uses these for abandoned cart + upsell frequency caps.
 */
 
function getCookie(name) {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(';').shift()
  return null
}
 
function setCookie(name, value, days) {
  const expires = new Date()
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000)
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`
}
 
export function updateTriggerCookie(agentId, url, value = -1) {
  if (!agentId) return 0
  const resolvedUrl = url || window.location.href.split('?')[0]
  const encodedUrl = btoa(resolvedUrl)
  const cookieName = `ochatbot_visit_${agentId}`
  const cookieVal = getCookie(cookieName)
 
  if (!cookieVal) {
    const cookieData = { [encodedUrl]: value >= 0 ? value : 1 }
    setCookie(cookieName, btoa(JSON.stringify(cookieData)), 30)
    return value >= 0 ? value : 1
  }
 
  try {
    const json = JSON.parse(atob(cookieVal))
    if (json[encodedUrl]) {
      json[encodedUrl] = value >= 0 ? value : json[encodedUrl] + 1
    } else {
      json[encodedUrl] = value >= 0 ? value : 1
    }
    setCookie(cookieName, btoa(JSON.stringify(json)), 30)
    return json[encodedUrl]
  } catch {
    const cookieData = { [encodedUrl]: value >= 0 ? value : 1 }
    setCookie(cookieName, btoa(JSON.stringify(cookieData)), 30)
    return value >= 0 ? value : 1
  }
}
 
export function getTriggerCount(agentId, url) {
  if (!agentId) return 0
  const resolvedUrl = url || window.location.href.split('?')[0]
  const encodedUrl = btoa(resolvedUrl)
  const cookieName = `ochatbot_visit_${agentId}`
  const cookieVal = getCookie(cookieName)
  if (!cookieVal) return 0
  try {
    const json = JSON.parse(atob(cookieVal))
    return json[encodedUrl] || 0
  } catch {
    return 0
  }
}
 
export function resetTriggerCookie(agentId, url) {
  updateTriggerCookie(agentId, url, 0)
}
 
function setExpiringLocalFlag(key, value, days = 30) {
  try {
    const expires = Date.now() + days * 24 * 60 * 60 * 1000
    localStorage.setItem(key, JSON.stringify({ value, expires }))
  } catch {
    // ignore
  }
}
 
function getExpiringLocalFlag(key) {
  try {
    const stored = localStorage.getItem(key)
    if (!stored) return 0
    const data = JSON.parse(stored)
    if (data?.expires && Date.now() > data.expires) {
      localStorage.removeItem(key)
      return 0
    }
    return data?.value || 0
  } catch {
    try {
      localStorage.removeItem(key)
    } catch {
      // ignore
    }
    return 0
  }
}
 
export function updateAbandonedCartCookie(agentId, type, value) {
  if (!agentId) return
  setExpiringLocalFlag(`ometricsAbandonedCart_${agentId}_${type}`, value, 30)
}
 
export function getAbandonedCartCookie(agentId, type) {
  if (!agentId) return 0
  return getExpiringLocalFlag(`ometricsAbandonedCart_${agentId}_${type}`)
}
 
export function updateUpsellSeenCookie(agentId, value) {
  if (!agentId) return
  setExpiringLocalFlag(`ometricsUpsellSeen_${agentId}`, value, 30)
}
 
export function getUpsellSeenCookie(agentId) {
  if (!agentId) return 0
  return getExpiringLocalFlag(`ometricsUpsellSeen_${agentId}`)
}
 
const freeShippingIntentSessionKey = (agentId) =>
  `ometricsFreeShippingIntentFired_${agentId}`

/** Session-scoped so the free-shipping intent fires once per browser session. */
export function getFreeShippingIntentSessionFlag(agentId) {
  if (!agentId) return 0
  try {
    return sessionStorage.getItem(freeShippingIntentSessionKey(agentId)) === '1' ? 1 : 0
  } catch {
    return 0
  }
}

export function setFreeShippingIntentSessionFlag(agentId, value) {
  if (!agentId) return
  try {
    if (value) {
      sessionStorage.setItem(freeShippingIntentSessionKey(agentId), '1')
    } else {
      sessionStorage.removeItem(freeShippingIntentSessionKey(agentId))
    }
  } catch {
    // ignore (storage unavailable)
  }
}

export function cleanupExpiredAbandonedCartFlags() {
  if (typeof Storage === 'undefined' || !localStorage) return 0
  const prefix = 'ometricsAbandonedCart_'
  const now = Date.now()
  let cleaned = 0
  try {
    const keys = Object.keys(localStorage).filter((k) => k.startsWith(prefix))
    for (const key of keys) {
      try {
        const stored = localStorage.getItem(key)
        if (!stored) continue
        const data = JSON.parse(stored)
        if (data?.expires && now > data.expires) {
          localStorage.removeItem(key)
          cleaned += 1
        }
      } catch {
        try {
          localStorage.removeItem(key)
          cleaned += 1
        } catch {
          // ignore
        }
      }
    }
  } catch {
    // ignore
  }
  return cleaned
}

